import React from "react";
import {useTranslation} from "react-i18next";
import {getTextBackgroundClassNameByPersonType} from "utils/driverUtils";
import {PersonType} from "types/enums/PersonType";
import FeatherIcon from "components/FeatherIcon";
import {translate} from "utils/utility";
import {clsx} from "clsx";
import {PackageItem} from "types/entities/PackageItem";
import {ReservationDriver} from "types/entities/ReservationDriver";
import OnlineTicket from "components/Icons/OnlineTicket";
import CreditTicketPackageItem from "./CreditTicketPackageItem";

const AccessTicketItemHeader = (props: {
    i: number;
    isAssignationPanelOpen: boolean;
    packageItem: PackageItem | null;
    reservationDriver: ReservationDriver | null;
    openEditTicketAssignmentHandler: () => void;
}) => {
    const {t} = useTranslation();
    return (
        <section
            className={
                "AccessTicketHeader flex flex-row justify-start items-stretch min-h-[36px] bg-gray-50 text-black hover:bg-gray-100 active:focus:bg-gray-100  cursor-pointer w-full"
            }
            aria-label={"Access ticket driver"}
            aria-expanded={props.isAssignationPanelOpen}
            aria-controls={"AccessTicketDriversAssign"}
            onClick={() => props.openEditTicketAssignmentHandler()}
        >
            <div
                className={clsx(
                    "AccessTicketPos inline-flex items-center justify-center text-xs md:text-xl px-3 py-1.5 font-semibold md:font-medium w-[40px] md:w-[50px]  text-white shrink-0 overflow-hidden rounded-br-[5px] md:rounded-br-[10px]",
                    getTextBackgroundClassNameByPersonType(
                        props.reservationDriver ? props.reservationDriver.person_type : (props.packageItem?.person_type as unknown as PersonType)
                    )
                )}
            >
                {props.i}
            </div>
            <div className="AccessTicketName py-2  basis-[400px] shrink font-semibold md:font-medium text-xs md:text-xl text-left flex flex-row items-center justify-start gap-x-2 md:gap-x-4 pl-[11px] md:pl-[31px]">
                {props.packageItem && (
                    <div className={"AccessTicketNameText flex flex-row justify-center items-center gap-3"}>
                        <OnlineTicket />
                        <span>
                            {t("Entry")}: <strong>{t("entry_duration:", {duration: props.packageItem.duration / 60})}</strong>
                        </span>
                        <label className={"hidden"} aria-hidden="true">
                            {translate(props.packageItem.name)}
                        </label>
                    </div>
                )}
                <span
                    className={
                        "AccessTicketPersonType OnlyShowOnChilren font-light text-xxs md:text-sm pl-1 pr-2 grow text-right place-content-end self-center"
                    }
                >
                    {props.packageItem && props.packageItem.person_type && (props.packageItem.person_type != "adult" ? t("child ticket") : "")}
                </span>
            </div>
            <CreditTicketPackageItem personIndex={props.i - 1} />
            <div className={"AccessTicketAction flex items-center justify-end"}>
                <div className={"px-[12px] md:px-[16px] py-[10px] text-black"}>
                    <FeatherIcon className={"size-[20px] md:size-[30px]"} name={"edit"} strokeWidth={2} />
                </div>
            </div>
        </section>
    );
};

export default AccessTicketItemHeader;
